import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from './TopNav';
import Footer from './Footer';

const MusicPage = () => {
  return (
    <div className="music-page">
      <TopNav />
      <div className="music-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="page-title">Music</h1>
        <p className="page-subtitle">What I've been listening to</p>
        
        <div className="playlist-wrapper">
          <iframe
            src="https://www.youtube.com/embed/videoseries?list=PLu6m0srvUrA7OQY3-dN5hLYSNxuPNLtp6"
            title="YouTube Playlist"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="playlist-iframe"
          ></iframe>
        </div>
        
        <Footer />
      </div>

      <style jsx>{`
        .music-page {
          min-height: 100vh;
          background: #151312;
          padding: 40px 20px;
        }

        .music-container {
          max-width: 1000px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: calc(100vh - 80px);
        }

        .back-link {
          align-self: flex-start;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: #f46c38;
          text-decoration: none;
          margin-bottom: 40px;
          transition: opacity 0.2s ease;
        }

        .back-link:hover {
          opacity: 0.8;
        }

        .page-title {
          font-family: 'Poppins', sans-serif;
          font-size: 48px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 12px;
          text-align: center;
        }

        .page-subtitle {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          color: #998f8f;
          margin-bottom: 40px;
          text-align: center;
        }

        .playlist-wrapper {
          width: 100%;
          max-width: 800px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .playlist-iframe {
          width: 100%;
          aspect-ratio: 16 / 9;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
        }

        @media (max-width: 768px) {
          .music-page {
            padding: 20px 16px;
          }

          .music-container {
            min-height: calc(100vh - 40px);
          }

          .page-title {
            font-size: 32px;
          }

          .page-subtitle {
            font-size: 14px;
            margin-bottom: 24px;
          }

          .back-link {
            margin-bottom: 24px;
          }

          .playlist-wrapper {
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default MusicPage;
